import React from 'react';
import { createRoot } from 'react-dom/client';
import { Trans } from 'react-i18next';
import { FormRow } from 'src/components/Form';
import Button from 'src/components/Button';
import Popup from './Popup';
import PopupSection from './PopupSection';

export { Popup, PopupSection };

export default Popup;

export const popupAlert = ({
  body,
  executeCloseCallback= false,
  onCloseCallback,
  onSubmit,
  hasCancel = false,
  ...properties
}) => {
  const divTarget = document.createElement('div');
  document.body.appendChild(divTarget);
  const root = createRoot(divTarget);

  const onClose = (executeCallBack = true) => {
    root.unmount();
    divTarget.parentNode.removeChild(divTarget);
    if (executeCallBack && onCloseCallback && typeof onCloseCallback === 'function') {
      onCloseCallback();
    }
  };

  root.render((
    // eslint-disable-next-line react/jsx-filename-extension
    <Popup
      {...properties}
      onClose={() => onClose(executeCloseCallback)}
      >
      {body}
      <FormRow center inline spaced>
        <Button onClick={() => {
          onClose(false);
          onSubmit();
        }} rounded orange solid type="button">
          <Trans>OK</Trans>
        </Button>
        {hasCancel && (
          <Button onClick={() => {
            onClose(executeCloseCallback);
          }} rounded orange solid type="button">
            <Trans>CANCEL</Trans>
          </Button>
        )}
      </FormRow>
    </Popup>
  ), divTarget);
};

